import {required} from 'redux-form-validators'


export function validateAddress(value: string | undefined | null): string | undefined {
        if (value === undefined || value === null) {
            return undefined
        }

        const requiredError = required({msg: 'field is required' })(value)
        if (requiredError) {
            return requiredError
        }

        if (!/^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s,.\-ºª/#()%']*$/.test(value)) {
            return 'Only alphanumeric characters are allowed'
        }

        return undefined
}


export function validateAddressTwo(value: string | undefined | null): string | undefined {
    if (value === undefined || value === null) {
        return undefined
    }

    if (!/^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s,.\-ºª/#()%']*$/.test(value)) {
        return 'Only alphanumeric characters are allowed'
    }

    return undefined
}
